import React from "react";
import PropTypes from "prop-types";
import { useChallenge } from "../../../hooks/useChallenge";
import LoadingAnimation from "../../../common/components/base/LoadingAnimation";
import ChallengePanel from "../ChallengePanel";
import SandboxLayout from "../../../hoc/SandboxLayout/SandboxLayout";
import { campaignAdsManagerData } from "../../../utils/data/sandboxes";

const SecondStepChallengeLayout = props => {
  const { pageName, challengeType } = props;
  
  // Fetch challenge data using REST hook
  const { data: challengeData, isLoading, error } = useChallenge(challengeType);
  
  return (
    <SandboxLayout name={pageName} challengeMode={true} layoutData={campaignAdsManagerData}>
      <div className="wizard-container">
        <div className="col-md-8 col-12 mr-auto ml-auto">
          <div
            className="card card-wizard active"
            data-color="rose"
            id="wizardProfile"
          >
            {isLoading && <LoadingAnimation />}
            {error && <div>Error! {error.message}</div>}
            {challengeData && (() => {
              console.log("Challenge data in SecondStepChallengeLayout:", challengeData);
              const challenge = typeof challengeData.challengeDefinition === 'string' 
                ? JSON.parse(challengeData.challengeDefinition) 
                : challengeData.challengeDefinition;
              
              return (
                <div>
                  {props.children}
                  <ChallengePanel
                    time={challenge.steps[1].countdownTime}
                    description={challenge.challengeDescription}
                    coach={challenge.coach}
                    challengeTitle={challenge.challengeTitle}
                    challengeIsValidation={challenge.isValidation}
                    challengeDifficulty={challenge.challengeDifficulty}
                    challengeAverageTime={challenge.averageTime}
                  />
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    </SandboxLayout>
  );
};

SecondStepChallengeLayout.propTypes = {
  pageName: PropTypes.string.isRequired,
  challengeType: PropTypes.number.isRequired
};

SecondStepChallengeLayout.defaultTypes = {
  pageName: ""
};

export default SecondStepChallengeLayout;
